import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import CountUp from 'react-countup';
import { Profit, Loss } from '../../Constant';
import { TicketData } from '../../Data/SupportTicket';
import { H4, LI, UL, H6 } from '../../AbstractElements';

const TicketList = () => {
  return (
    <Row>
      {TicketData.map((item, index) => {
        return (
          <Col xl='4' sm='6' key={index}>
            <Card className='ecommerce-widget pro-gress'>
              <CardBody className='support-ticket-font'>
                <Row>
                  <Col xs='5'>
                    <H6>{item.title}</H6>
                    <H4 className='total-num counter'>
                      <CountUp end={item.num} className='text-dark' />
                    </H4>
                  </Col>
                  <Col xs='7'>
                    <div className='text-md-end'>
                      <UL className='simple-list'>
                        <LI>
                          {Profit}
                          <span className='product-stts txt-primary ms-2'>
                            {'8989'}
                            <i className='icon-angle-up f-12 ms-2 me-0'></i>
                          </span>
                        </LI>
                        <LI>
                          {Loss}
                          <span className='product-stts txt-danger ms-2'>
                            {'2560'}
                            <i className='icon-angle-down f-12 ms-2 me-0'></i>
                          </span>
                        </LI>
                      </UL>
                    </div>
                  </Col>
                </Row>
                <div className='progress-showcase'>
                  <div className='progress'>
                    <div className={item.class} style={{ width: '70%' }}></div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};
export default TicketList;
